











import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Popup extends Vue {
  @Prop({default: 'Example'})
  imagePath!: string;

  private onClick() {
    this.$emit("close");
    console.log(this.imagePath);
  }
}
